import { useEffect, useRef } from "react";
import { useInView, useMotionValue, useSpring } from "framer-motion";

export const StatCounter = ({ value, prefix = "", suffix = "", className = "", testId }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const mv = useMotionValue(0);
  const spring = useSpring(mv, { duration: 2000, bounce: 0 });

  useEffect(() => {
    if (inView) mv.set(value);
  }, [inView, value, mv]);

  useEffect(
    () =>
      spring.on("change", (v) => {
        if (ref.current)
          ref.current.textContent = `${prefix}${Math.round(v).toLocaleString("en-ZA")}${suffix}`;
      }),
    [spring, prefix, suffix]
  );

  return (
    <span ref={ref} className={className} data-testid={testId}>
      {prefix}0{suffix}
    </span>
  );
};
